export default (bottle) => {
  bottle.constant('HELP_INDEX', 'help');
  bottle.constant('PREVIEW_INDEX', 'preview');
  bottle.constant('SINGLE_INDEX', 'single');
  bottle.constant('MULTI_INDEX', 'multi');
};
